import React from 'react';
import { Link } from 'react-router';
import { I18n as I } from 'react-redux-i18n';
import { formatCurrencyRounded } from 'vdlib';
import Counter from './Counter';

const counterClassName = 'col-md-4 col-sm-6 col-12';

const InsuranceDashboard = ({
  TotalActiveAuctionAmount,
  TotalActiveAuctionCount,
  TotalForApproveAuctionAmount,
  TotalForApproveAuctionCount,
  TotalFinishedAuctionAmount,
  TotalFinishedAuctionCount,
  TotalForAcceptAuctionAmount,
  TotalForAcceptAuctionCount,
  TotalForSelectAuctionAmount,
  TotalForSelectAuctionCount,
}) => (
  <div>
    <hr className="clear" />
    <div className="row">
      <Link to="/auctions" className={counterClassName}>
        <Counter
          colorClassName="green"
          icon="line-chart"
          title={I.t('CURRENT')}
          value={TotalActiveAuctionCount}
          amount={formatCurrencyRounded(TotalActiveAuctionAmount)}
        />
      </Link>
      <Link to="/auctions/for-selection" className={counterClassName}>
        <Counter
          colorClassName="yellow"
          icon="trophy"
          title={I.t('FOR_SELECTION')}
          value={TotalForSelectAuctionCount}
          amount={formatCurrencyRounded(TotalForSelectAuctionAmount)}
        />
      </Link>
      <Link to="/auctions/completed" className={counterClassName}>
        <Counter
          colorClassName="blue"
          icon="thumbs-up"
          title={I.t('COMPLETED_PL_FEM')}
          value={TotalFinishedAuctionCount}
          amount={formatCurrencyRounded(TotalFinishedAuctionAmount)}
        />
      </Link>
    </div>
    <div className="row">
      <Link to="/auctions/pending-approval" className={counterClassName}>
        <Counter
          colorClassName="blue"
          icon="legal"
          title={I.t('PENDING_APPROVAL')}
          value={TotalForApproveAuctionCount}
          amount={formatCurrencyRounded(TotalForApproveAuctionAmount)}
        />
      </Link>
      <Link to="/auctions/for-acceptance" className={counterClassName}>
        <Counter
          colorClassName="red"
          icon="check"
          title={I.t('FOR_ACCEPTANCE')}
          value={TotalForAcceptAuctionCount}
          amount={formatCurrencyRounded(TotalForAcceptAuctionAmount)}
        />
      </Link>
    </div>
  </div>
);

export default InsuranceDashboard;
